import {useEffect, useState} from "react";
import {useLeadStore} from "../store/Lead.store";

export default function useBelfiusTheme() {
    const store = useLeadStore();
    const [belfiusThemeState, setBelfiusThemeState] = useState<boolean>( false );
    const [themeClassName, setThemeClassName] = useState<string>( "" );

    useEffect( () => {
        if ( store.configuration.theme.toUpperCase() === "BELFIUS" ) {
            setBelfiusThemeState( true );
            setThemeClassName( "belfius" );
        }
    }, [store.configuration.theme] );

    return {
        belfiusThemeState,
        themeClassName
    }//[belfiusThemeState, themeClassName];
}
